module.exports = __webpack_public_path__ + "static/img/enlarge-circular-1.47c0276d.png";